/**
=========================================================
* Trust Cargo - View Container
=========================================================

* One container: every customer in it once, with their totals, price, extra,
* commission and confirmed CBM - see ContainerCustomers.
*
* The page used to end with a second table, "View Container #id", of the
* old system's item lines (order code, our item, photo, QTY/CTN ...), read
* from the old database's specefic_container. It held nothing for a v2
* container and the office asked for it to go, so the page is only the
* customers now.
*/

import { useLocation } from "react-router-dom";

import SuiBox from "components/SuiBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ContainerCustomers from "./ContainerCustomers";

function ViewContainer() {
  const route = useLocation().pathname.split("/").slice(1);

  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <ContainerCustomers containerId={route[route.length - 1]} />
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ViewContainer;
